module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf3a3a2e6f295df3289eeea2b3ac9936f.f3a3a2e6.png";